<template>
    <div class="journey-stop">{{ label }} {{ time }}</div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { capitalize } from 'lodash';

    export default defineComponent({
        name: 'Location',
        methods: { t },
        props: {
            time: {
                type: String as PropType<string | null>,
            },
        },

        setup(props) {
            const label = capitalize(
                t({ key: 'shared.stop', suffix: props.time ? ':' : '' })
            );

            return { label };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Stop.scss';
</style>
